import React, { useEffect, useState } from 'react';
import "../../Css/Home/HomeCategory.css";
import image01 from "../../Images/icons/plywood.png";

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/grid';
import 'swiper/css/pagination'; // Only need pagination for your current setup

// import required modules
import { Pagination, Autoplay, Grid } from 'swiper/modules'; // Only need Pagination for your current setup
import axios from 'axios';
import { Link } from 'react-router-dom';

const HomeCategory = () => {
    // You have a static 'categories' array here, but you're fetching 'data' from API.
    // Make sure you intend to use 'data' for the Swiper slides.
    const categories = [
        { src: 'https://swiperjs.com/demos/images/nature-1.jpg', name: 'Marine Plywood' },
        { src: 'https://swiperjs.com/demos/images/nature-2.jpg', name: 'Commercial Plywood' },
        { src: 'https://swiperjs.com/demos/images/nature-3.jpg', name: 'Laminated Plywood' },
        { src: 'https://swiperjs.com/demos/images/nature-4.jpg', name: 'Flexible Plywood' },
        { src: 'https://swiperjs.com/demos/images/nature-5.jpg', name: 'Fire Retardant Plywood' },
        { src: 'https://swiperjs.com/demos/images/nature-6.jpg', name: 'Shuttering Plywood' },
        { src: 'https://swiperjs.com/demos/images/nature-7.jpg', name: 'Decorative Veneer Plywood' },
        { src: 'https://swiperjs.com/demos/images/nature-8.jpg', name: 'BWR Grade Plywood' },
        { src: 'https://swiperjs.com/demos/images/nature-9.jpg', name: 'BWP Grade Plywood' },
    ];

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleFetch = async () => {
        try {
            setLoading(true);
            const resp = await axios.get(`https://api.woodsy.co.in/api/subcategories`);
            if (resp && resp.data) {
                // The API seems to return an array directly based on previous code.
                // Object.values might be needed if it sometimes returns an object of objects.
                const categoryArray = Array.isArray(resp.data) ? resp.data : Object.values(resp.data);
                setData(categoryArray);
            }
        } catch (error) {
            console.error("Error fetching home categories:", error); // More specific error message
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const debounce = setTimeout(() => { // Renamed dbounce to debounce for standard naming
            handleFetch();
        }, 1000);
        return () => {
            clearTimeout(debounce);
        };
    }, []); // Empty dependency array means it runs once on mount

    return (
        <div>
            <section className='home-category-section'>
                <div className='container'>
                    <div className='home-category-section-main-con'>
                        {/* Section for 4 points/cards */}
                        <div className='home-category-section-3-points-main-con'>
                            <div className='row'>
                                {/* Using index as key is acceptable here as these are static and fixed */}
                                <div className='col-md-3' key="quality-card">
                                    <div className="home-category-section-3-points-card">
                                        <div className='home-category-section-3-points-card-details-svg'>
                                            <div className='home-category-section-3-points-card-details-img'>
                                                <img src={image01} alt="Quality icon" />
                                            </div>
                                        </div>
                                        <h3>Quality</h3>
                                        <p>Plywood Manufacturer and Supplier in Byculla.</p>
                                    </div>
                                </div>
                                <div className='col-md-3' key="design-card">
                                    <div className="home-category-section-3-points-card">
                                        <div className='home-category-section-3-points-card-details-svg'>
                                            <div className='home-category-section-3-points-card-details-img'>
                                                <img src={image01} alt="Design icon" />
                                            </div>
                                        </div>
                                        <h3>Design</h3>
                                        <p>Fits every modern home style.</p>
                                    </div>
                                </div>
                                <div className='col-md-3' key="durability-card">
                                    <div className="home-category-section-3-points-card">
                                        <div className='home-category-section-3-points-card-details-svg'>
                                            <div className='home-category-section-3-points-card-details-img'>
                                                <img src={image01} alt="Durability icon" />
                                            </div>
                                        </div>
                                        <h3>Durability</h3>
                                        <p>Strong enough for daily use.</p>
                                    </div>
                                </div>
                                <div className='col-md-3' key="sustainability-card">
                                    <div className="home-category-section-3-points-card">
                                        <div className='home-category-section-3-points-card-details-svg'>
                                            <div className='home-category-section-3-points-card-details-img'>
                                                <img src={image01} alt="Sustainability icon" />
                                            </div>
                                        </div>
                                        <h3>Sustainability</h3>
                                        <p>sourced responsibly, eco-friendly always.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='home-category-section-3-second-con'>
                            <div className='home-category-section-3-second-head-main-con'>
                                <h3>Top Category</h3>
                            </div>

                            <div className='home-category-section-3-second-card-con'>
                                {/* <div className='row'>
                                    <div className='col-md-2'>
                                        <div className='home-categoey-section-3-second-card-left-side-con'>
                                            <div className='title-tab'>
                                                <div className="title-block">
                                                    <div className="subtitle" style={{ color: "#666666" }}>Trending in this Season</div>
                                                    <h2 className="collection-title" style={{ color: "#222222" }}>Our Categories</h2>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-9'> */}
                                <div className='home-category-section-3-second-card-body-category-con'>
                                    {loading ? (
                                        <p>Loading top categories...</p> // Loading state for Swiper
                                    ) : (
                                        <Swiper
                                            slidesPerView={3}
                                            grid={{
                                                rows: 3,
                                            }}
                                            spaceBetween={30}
                                            pagination={{
                                                clickable: true,
                                            }}
                                            modules={[Grid, Pagination]}
                                            className="mySwiper homecategoryswiper"
                                        >
                                            {
                                                data.map((elem, index) => { // Added index here
                                                    // Use elem.id if available and unique, otherwise fallback.
                                                    // The `category-swiper-` prefix ensures uniqueness across your app.
                                                    const uniqueKey = elem.id || `category-swiper-${elem?.name || 'unknown'}-${index}`;
                                                    return (
                                                        // Key must be on the SwiperSlide component directly
                                                        <SwiperSlide key={uniqueKey} className='mt-0'>
                                                            <Link to={`product?sub_category_slug=${elem.slug}`}>
                                                                <div className='home-category-section-second-category-card-body'>
                                                                    <div className='home-category-section-second-category-card-image-con'>
                                                                        <img
                                                                            src={elem?.image}
                                                                            alt={elem?.name || "Category Image"} // Provide alt text
                                                                        />
                                                                    </div>
                                                                    <div className='home-category-section-second-category-card-details-con'>
                                                                        <h4>{elem?.name}</h4>
                                                                        <p>{elem?.description}</p>
                                                                    </div>
                                                                </div>
                                                            </Link>
                                                        </SwiperSlide>
                                                    );
                                                })
                                            }
                                        </Swiper>
                                    )}
                                    {!loading && data.length === 0 && <p>No top categories found.</p>}
                                </div>
                                {/* </div> */}
                                {/* </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default HomeCategory;